module.exports = __webpack_public_path__ + "static/media/IT-e-Telco.1ef4bc05.png";